<template>
    <tr>

        <td class="px-6 py-2">
            <i class="fa fa-lock" v-show="item.type === 'disabled'"  aria-hidden="true"></i>
            <i class="fa fa-eye-slash" aria-hidden="true" v-show="item.desk_type_id === 2"></i>
        </td>

        <td class="px-6 py-2">
            {{ item.name }}
            <span v-show="item.type === 'disabled'" class="text-red-300 text-sm">
                <br>{{ item.disabled_reason }}
            </span>
        </td>
        <td class="px-6 py-2">
            <floor-item :item="item.floor"></floor-item>
        </td>
        <td class="px-6 py-2">
            <zone-item v-for="zone in item.zones"
                             :item="zone"
                             :key="zone.id">
            </zone-item>     
        </td>
        <td class="px-6 py-2">
            <span v-if="item.user">
                <a :href="'/admin/users/' + item.user.id">
                    {{ item.user.name }}
                </a>
            </span>
        </td>
        <td class="px-6 py-2">
            <span
                v-for="attribute in item.attributes"
                class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                {{ attribute.name }}
            </span>
        </td>
        <td class="px-6 py-2" v-show="group.has_check_in">
            <q-r-code-view :code="item.qr_code" :name="item.name" :uuid="item.uuid"></q-r-code-view>
        </td>
        <td class="">
            <desk-edit class="mr-6" :item="item" @updated="$emit('updated')"></desk-edit>
            <span class="text-xs text-red-500" v-show="!item.position">
                <i class="fa fa-exclamation-triangle"></i>
                Lageplan?
            </span>
        </td>

    </tr>
</template>

<script>
import Modal from "./Modal";
import ButtonPrimary from "./UI/ButtonPrimary";
import ConfirmDialog from "./UI/ConfirmDialog";
import ButtonWhite from "./UI/ButtonWhite";
import InputText from "./UI/InputText";
import InputField from "./UI/InputField";
import ButtonSecondary from "./UI/ButtonSecondary";
import NavigationEdit from "./NavigationEdit";
import DeskEdit from "./DeskEdit";
import ZoneItem from "./ZoneItem.vue";
import FloorItem from "./FloorItem.vue";
import QRCodeView from './QRCodeView.vue';

export default {

    name: "DeskTableItem",

    components: {
        FloorItem,
        ZoneItem,
        DeskEdit,
        NavigationEdit,
        ButtonSecondary,
        InputField,
        InputText,
        ButtonWhite,
        ConfirmDialog,
        ButtonPrimary,
        Modal,
        QRCodeView
    },

    props: ['item', 'group'], 


}
</script>

<style scoped>

</style>
